import React from 'react';
import { Typography } from '@mui/material';
import { Add, WhatsApp } from '@mui/icons-material';
import PaperInfo from '../PaperInfo';
import useLogin from '../../hooks/useLogin';
import Button from '../Button';

interface Props {
  actionInfo?: () => void;
  actionTitle?: string;
  isConfigureWhats?: boolean;
}

export default function InfoCompany({
  actionInfo,
  isConfigureWhats,
  actionTitle,
}: Props) {
  const { userSelector } = useLogin();

  return (
    <PaperInfo>
      <Typography component="span" variant="h5" sx={{ color: 'black' }}>
        {userSelector.affiliate?.fantasy_name}
      </Typography>
      {actionInfo && (
        <Button
          id="actionInfoCompany"
          onClick={() => actionInfo()}
          caption={actionTitle ?? 'Ação'}
          startIcon={isConfigureWhats ? <WhatsApp /> : <Add />}
        />
      )}
    </PaperInfo>
  );
}

InfoCompany.defaultProps = {
  actionInfo: undefined,
  isConfigureWhats: false,
  actionTitle: undefined,
};
